module.exports = __webpack_public_path__ + "img/hands-joined-team.b602b8b6.jpg";